export default {
    setGamerData(state) {
        state.selectedGamerData = state.allGamerData[state.selectedGamer];
      },
    setGamer(state, payload){
      state.selectedGamer = payload.index;
    },
    setMySalary(state, payload){
      state.mySalary = payload.mySalary;
    }
}